import { render, staticRenderFns } from "./PriceContent.vue?vue&type=template&id=7580ad56&scoped=true&"
import script from "./PriceContent.vue?vue&type=script&lang=js&"
export * from "./PriceContent.vue?vue&type=script&lang=js&"
import style0 from "./PriceContent.vue?vue&type=style&index=0&id=7580ad56&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580ad56",
  null
  
)

export default component.exports